import Button from './Button';
import './Button.scss';

export default Button;
